<template>
    <main role="main" class="container">
        <div class="row">
            <div class="col-md-12">
                <h3 class="pb-4 mb-4 border-bottom">
                    Состояние заказов {{header}}
                </h3>
            </div>

            <aside class="col-md-4">
                <div class="p-4 mb-3 bg-light rounded">
                    <div class="row">
                        <div class="col-10">
                            <ol class="list-unstyled mb-0">
                                <li>
                                    <a href="javascript:" v-if="statuses[0].count != 0" v-bind:class="{ active: activeType == 1 }" @click="activate(1)">Ожидают передачи</a>
                                    <span v-else>Ожидают передачи</span>
                                    <a href="javascript:" class="help" v-tooltip.right="{content: 'Ваш заказ ожидает передачи из вашего личного кабинета в торговую систему компании \'КАТРИС\'. Время нахождения заказа в этом состоянии 10 - 15 минут', trigger: 'hover'}"><i class="las la-question-circle"></i></a>
                                </li>
                                <li>
                                    <a href="javascript:" v-if="statuses[1].count != 0" v-bind:class="{ active: activeType == 2 }" @click="activate(2)">Обрабатываются</a>
                                    <span v-else>Обрабатываются</span>
                                    <a href="javascript:" class="help" v-tooltip.right="{content: 'Ваш заказ передан в торговую систему компании \'КАТРИС\' и обрабатывается менеджером', trigger: 'hover'}"><i class="las la-question-circle"></i></a>
                                </li>
                                <li>
                                    <a href="javascript:" v-if="statuses[2].count != 0" v-bind:class="{ active: activeType == 3 }" @click="activate(3)">Ожидают оплаты</a>
                                    <span v-else>Ожидают оплаты</span>
                                    <a href="javascript:" class="help" v-tooltip.right="{content: 'Ваш заказ принят и обработан. Товар зарезервирован. Счет доступен к печати и оплате в течении 1 рабочего дня', trigger: 'hover'}"><i class="las la-question-circle"></i></a>
                                </li>
                                <li>
                                    <a href="javascript:" v-if="statuses[3].count != 0" v-bind:class="{ active: activeType == 4 }" @click="activate(4)">К производству</a>
                                    <span v-else>К производству</span>
                                    <a href="javascript:" class="help" v-tooltip.right="{content: 'Ваш заказ поставлен в производственную очередь, товар зарезервирован. В этом статусе Вы можете посмотреть дату планируемой отгрузки.', trigger: 'hover'}"><i class="las la-question-circle"></i></a>
                                </li>
                                <li>
                                    <a href="javascript:" v-if="statuses[4].count != 0" v-bind:class="{ active: activeType == 5 }" @click="activate(5)">В производстве</a>
                                    <span v-else>В производстве</span>
                                    <a href="javascript:" class="help" v-tooltip.right="{content: 'Ваш заказ находится в производстве. Отменить заказ в этом состоянии нельзя', trigger: 'hover'}"><i class="las la-question-circle"></i></a>
                                </li>
                                <li>
                                    <a href="javascript:" v-if="statuses[5].count != 0" v-bind:class="{ active: activeType == 6 }" @click="activate(6)">Собираются</a>
                                    <span v-else>Собираются</span>
                                    <a href="javascript:" class="help" v-tooltip.right="{content: 'Ваш заказ находится на подборе. Отменить заказ в этом состоянии нельзя', trigger: 'hover'}"><i class="las la-question-circle"></i></a>
                                </li>
                                <li>
                                    <a href="javascript:" v-if="statuses[6].count != 0" v-bind:class="{ active: activeType == 7 }" @click="activate(7)">Готовые к отгрузке</a>
                                    <span v-else>Готовые к отгрузке</span>
                                    <a href="javascript:" class="help" v-tooltip.right="{content: 'Ваш заказ изготовлен и готов к отгрузке. Отменить заказ в этом состоянии нельзя.', trigger: 'hover'}"><i class="las la-question-circle"></i></a>
                                </li>
                                <li>
                                    <a href="javascript:" v-if="statuses[7].count != 0" v-bind:class="{ active: activeType == 8 }" @click="activate(8)">Прошлые заказы</a>
                                    <span v-else>Прошлые заказы</span>
                                    <a href="javascript:" class="help" v-tooltip.right="{content: 'Здесь находятся все реализованные заказы', trigger: 'hover'}"><i class="las la-question-circle"></i></a>
                                </li>
                                <li>
                                    <a href="javascript:" v-if="statuses[8].count != 0" v-bind:class="{ active: activeType == 9 }" @click="activate(9)">Отмененные</a>
                                    <span v-else>Отмененные</span>
                                    <a href="javascript:" class="help" v-tooltip.right="{content: 'Ваш заказ не был оплачен в течении 1 рабочего дня. Товар снят с резерва. Свяжитесь со своим менеджером, чтобы восстановить заказ', trigger: 'hover'}"><i class="las la-question-circle"></i></a>
                                </li>
                                <li>
                                    <a href="javascript:" v-if="statuses[9].count != 0" v-bind:class="{ active: activeType == 10 }" @click="activate(10)">Отвергнутые</a>
                                    <span v-else>Отвергнутые</span>
                                    <a href="javascript:" class="help" v-tooltip.right="{content: 'В состояние отвергнутые попадают заказы, удаленные из торговой системы компании \'КАТРИС\' в результате взаимного согласия или признания заказа ошибочным', trigger: 'hover'}"><i class="las la-question-circle"></i></a>
                                </li>
                            </ol>
                        </div>
                        <div class="col-2">
                            <ol class="list-unstyled mb-0">
                                <li>{{statuses[0].count}}</li>
                                <li>{{statuses[1].count}}</li>
                                <li>{{statuses[2].count}}</li>
                                <li>{{statuses[3].count}}</li>
                                <li>{{statuses[4].count}}</li>
                                <li>{{statuses[5].count}}</li>
                                <li>{{statuses[6].count}}</li>
                                <li>{{statuses[7].count}}</li>
                                <li>{{statuses[8].count}}</li>
                                <li>{{statuses[9].count}}</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </aside>

            <div class="col-md-8">
                <div id="right" class="right" v-if="activeType != 0">
                    <p style="text-align: center">Выберите промежуток:</p>
                    <div class="row justify-content-center" style="margin-bottom: 20px;">
                        <div class="col-sm-9 col-md-9 col-lg-6">
                            <div class="input-group dates">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">С:</span>
                                </div>
                                <datepicker placeholder="С" :language="ru" :monday-first="true" input-class="form-control" v-model="dateFrom" format="dd.MM.yyyy"></datepicker>
                                <div class="input-group-addon">
                                    <span class="input-group-text">По:</span>
                                </div>
                                <datepicker placeholder="По" :language="ru" :monday-first="true" input-class="form-control" v-model="dateTo" format="dd.MM.yyyy"></datepicker>
                            </div>
                        </div>
                        <div class="col-12 col-md-3 col-lg-3 text-center">
                            <button id="" name="last" class="btn btn-outline-primary m-3 m-sm-3 m-md-0 m-lg-0" @click="getOrders()">Показать</button>
                        </div>
<!--                        <div class="col">-->
<!--                            <div class="input-group">-->
<!--                                <div class="input-group-prepend">-->
<!--                                    <span class="input-group-text">С:</span>-->
<!--                                </div>-->
<!--                                <datepicker placeholder="С" :language="ru" :monday-first="true" input-class="form-control" v-model="dateFrom" format="dd.MM.yyyy"></datepicker>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="col">-->
<!--                            <div class="input-group">-->
<!--                                <div class="input-group-addon">-->
<!--                                    <span class="input-group-text">По:</span>-->
<!--                                </div>-->
<!--                                <datepicker placeholder="По" :language="ru" :monday-first="true" input-class="form-control" v-model="dateTo" format="dd.MM.yyyy"></datepicker>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="col">-->
<!--                            <button id="" name="last" class="btn btn-outline-primary" @click="getOrders()">Показать</button>-->
<!--                        </div>-->
                    </div>

                    <table class="table ordersState">
                        <thead>
                        <tr>
                            <td style="width: 136px;">Номер заказа</td>
                            <td style="width: 119px;">Дата<br>заведения</td>
                            <td style="width: 147px;"><span v-if="[1, 2, 3, 10].indexOf(activeType) == -1">Планируемая<br>дата<br>отгрузки</span></td>
                            <td style="width: 143px;">Способ<br>доставки</td>
                            <td style="width: 183px;" colspan="2">Документы</td>
                        </tr>
                        </thead>
                    </table>
                    <table class="table ordersState" v-for="(counteragent, index) in names" v-bind:key="index">
                        <tbody>
                        <tr>
                            <td colspan="6" class="text-center">{{counteragent}}</td>
                        </tr>
                        </tbody>

                        <tbody v-for="order in orders[index]" v-bind:key="order.orderId">
                        <tr class="orderTop" >
                            <td data-label="Номер заказа">{{order.idByClient != '' ? order.idByClient : order.orderId}}</td>
                            <td data-label="Дата заведения">{{order.date}}</td>
                            <td data-label="Планируемая дата отгрузки" style="min-height: 46px;"><span v-if="[1, 2, 3, 10].indexOf(activeType) == -1">{{order.readyDate}}</span></td>
                            <td data-label="Способ доставки">{{order.delivery}}</td>
                            <td class="sm-hide"><span v-if="[1, 2].indexOf(activeType) == -1">Счет:</span></td>
                            <td data-label="Счет">
                                <a v-if="[1, 2].indexOf(activeType) == -1" href="javascript:" @click="openInvoice(order.orderId, 2)"><img src="@/assets/img/pdf.png" alt="PDF"></a>
                                <a v-if="[1, 2].indexOf(activeType) == -1" href="javascript:" @click="openInvoice(order.orderId, 1)"><img src="@/assets/img/html.png" alt="HTML"></a>
                                <a v-if="[1, 2].indexOf(activeType) == -1" href="javascript:" @click="openInvoice(order.orderId, 3)"><img src="@/assets/img/xlsx.png" style="width: 40px" alt="XLSX"></a>
                            </td>
                        </tr>
                        <tr class="orderBottom">
                            <td colspan="3" data-label="">
                                <button class="btn btn-secondary mr-2" @click="openOrder(order.orderId)">Открыть</button>
                                <button v-if="[1, 2].indexOf(activeType) == -1 && order.type == 0" class="btn btn-secondary" @click="reorder(order.orderId)">Повторить заказ</button>
                                <button v-else-if="[1, 2].indexOf(activeType) == -1" class="btn btn-secondary" @click="$router.push({path: '/readyMade/' + order.orderId})">Повторить заказ</button>
                            </td>
                            <td class="sm-hide text-right">
                                <span v-if="[1, 2].indexOf(activeType) == -1">Упаковочный<br>лист:</span>
                            </td>
                            <td colspan="2" data-label="Упаковочный лист">
                                <a v-if="[1, 2].indexOf(activeType) == -1" href="javascript:" @click="openPackageList(order.orderId, 1)"><img align="top" src="@/assets/img/pdf.png" alt="PDF">по коробкам</a><br>
                                <a v-if="[1, 2].indexOf(activeType) == -1" href="javascript:" @click="openPackageList(order.orderId, 2)"><img align="top" src="@/assets/img/pdf.png" alt="PDF">по товарам</a>
                            </td>
                        </tr>

                        <tr>
                            <td colspan="6"></td>
                        </tr>
                        </tbody>
                    </table>
                    <p v-if="noItems" class="alert alert-dark">Нет позиций за выбранный период.</p>
                </div>
            </div>
        </div>

        <modal name="reorder" :min-width="200"
               :min-height="200"
               :adaptive="true"
               :scrollable="true"
               :reset="true"
               width="600px"
               height="auto">
            <div style="padding: 20px">
                <div v-if="reorderStatus">
                    <h3>Все позиции доступны для заказа. Продолжить?</h3>
                </div>
                <div v-else>
                    <h3>К сожалению, следующих позиций нет на складе:</h3>
                    <table class="table">
                        <tr><td>Наименование</td><td>Ожидаемый приход</td></tr>
                        <tr v-for="item in reorderItemsListAbsent" v-bind:key="item.name">
                            <td>
                                {{item.name}}
                            </td>
                            <td>
                                {{item.prihod}}
                            </td>
                        </tr>
                    </table>
                    <h3>Продолжить без этих позиций?</h3>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <input type="button" class="btn btn-primary btn-block" value="Продолжить" @click="step2()" />
                    </div>
                    <div class="col-md-6">
                        <input type="button" class="btn btn-primary btn-block" value="Отмена" @click="$modal.hide('reorder')" />
                    </div>
                </div>
            </div>
        </modal>
    </main>
</template>

<script>
    import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
    import {ru} from 'vuejs-datepicker/dist/locale'
    import rm_katris from '../js/rm_katris/app';
    import Vue from "vue";

    let today = new Date();

    function downloadBase64File (base64Data, fileName, mimeType) {
        // Декодируем base64 в бинарные данные
        const byteCharacters = atob(base64Data)
        const byteNumbers = new Array(byteCharacters.length)

        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i)
        }

        const byteArray = new Uint8Array(byteNumbers)
        const blob = new Blob([byteArray], { type: mimeType })

        // Создаем ссылку для скачивания
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = fileName

        // Добавляем ссылку в DOM, эмулируем клик и удаляем ссылку
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        // Освобождаем память (revoke URL после скачивания)
        setTimeout(() => URL.revokeObjectURL(url), 100)
    }

    export default {
        name: "OrdersState",
        metaInfo: {
            title: 'Состояние заказов',
            titleTemplate: '%s - sale.katris'
        },
        data() {
            return {
                orders: [],
                names: [],
                activeType: 0,
                showDates: false,
                dateFrom: today.setMonth(today.getMonth() - 1),
                dateTo: new Date(),
                ru: ru,
                statuses: [
                    {name: 'Ожидают передачи', count: 0},
                    {name: 'Обрабатываются', count: 0},
                    {name: 'Ожидают оплаты', count: 0},
                    {name: 'К производству', count: 0},
                    {name: 'В производстве', count: 0},
                    {name: 'Собираются', count: 0},
                    {name: 'Готовые к отгрузке', count: 0},
                    {name: 'Прошлые заказы', count: 0},
                    {name: 'Отмененные', count: 0},
                    {name: 'Отвергнутые', count: 0}
                ],
                noItems: false,
                reorderStatus: true,
                reorderItemsListAbsent: [],
                header: '',
            }
        },
        components: {
            Datepicker
        },
        created() {
            let self = this;

            rm_katris.params.url = 'https://sale.katris.ru/proxy/';
            rm_katris.params.session = this.$session.get('user');
            rm_katris.user = this.$session.get('user');

            rm_katris.makePost('katrisOrdersState', 'getOrdersCount', {}, null, function(response) {
                // console.log(response)
                if (response.status === 'OK') {
                    self.statuses[0].count = response.data[0] != undefined ? response.data[0] : 0; //Ожидают передачи
                    self.statuses[1].count = response.data[1] != undefined ? response.data[1] : 0; //Обрабатываются
                    self.statuses[2].count = response.data[3] != undefined ? response.data[3] : 0; //Ожидают оплаты
                    self.statuses[3].count = response.data[10] != undefined ? response.data[10] : 0; //К производству
                    self.statuses[4].count = response.data[9] != undefined ? response.data[9] : 0; //В производстве
                    self.statuses[5].count = response.data[8] != undefined ? response.data[8] : 0; //Собираются
                    self.statuses[6].count = response.data[11] != undefined ? response.data[11] : 0; //Готовые к отгрузке
                    self.statuses[7].count = response.data[5] != undefined ? response.data[5] : 0; //Прошлые заказы
                    self.statuses[8].count = response.data[4] != undefined ? response.data[4] : 0; //Отмененные
                    self.statuses[9].count = response.data[6] != undefined ? response.data[6] : 0; //Отвергнутые
                }
            });
        },
        methods: {
            activate: function(type) {
                if (this.activeType != type) {
                    this.header = '- ' + this.statuses[type - 1].name;
                    this.activeType = type;
                    this.orders = [];
                    this.names = [];
                }
            },
            getOrders: function() {
                let self = this;
                rm_katris.makePost('katrisOrdersState', 'getOrdersList', {'type': self.activeType, 'from': String(~~(new Date(self.dateFrom).getTime() / 1000)), 'to': String(~~(new Date(self.dateTo).getTime() / 1000))}, null, function(response) {
                    self.noItems = true;
                    self.names = [];
                    self.orders = [];

                    let i = 0;
                    for (let key in response.data) {
                        self.noItems = false;
                        self.names.push(key);
                        if (!self.orders[i]) {
                            self.orders[i] = [];
                        }
                        for (let key2 in response.data[key]) {
                            if (response.data[key][key2].readyDate) {
                                let date =  new Date(response.data[key][key2].readyDate * 1000);
                                let month = date.getMonth() + 1;
                                response.data[key][key2].readyDate = date.getDate() + '.' + (month < 10 ? '0' : '') + month + '.' + date.getFullYear();
                            }
                            self.orders[i].push(response.data[key][key2]);
                        }

                        i++;
                    }
                });
            },
            openInvoice: function(orderId, type) {
                let session = Vue.prototype.$session.get('user');
                let sber = false
                if (session.managers_employee_id == 61 || session.managers_employee_id == 100) {
                    sber = true
                }

                console.log(session, session.managers_employee_id, sber)

                rm_katris.makePost('katrisOrdersState', 'getInvoice', {'type': type, 'orderId': orderId, 'sber': sber}, null, function(response) {
                    if (type == 1) {
                        let newWindow = window.open("");
                        newWindow.document.body.innerHTML = response.data;
                    } else if (type == 2) {
                        let newWindow = window.open("");
                        newWindow.document.write(
                            "<body style='margin:0'><iframe style='border: none;' width='100%' height='100%' src='data:application/pdf;base64, " +
                            encodeURI(response.data) + "'></iframe></body>"
                        )
                    } else if (type == 3) {
                        rm_katris.makePost('funnelCRM', 'temp_invoice', response.data, null, function(response) {
                            console.log(response)
                            if (response.status === 'OK') {
                                downloadBase64File(response.data, 'bill.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
                            }
                        })
                    }
                });
            },
            openPackageList: function(orderId, type) {
                rm_katris.makePost('katrisOrdersState', 'getPackageList', {'type': type, 'orderId': orderId}, null, function(response) {
                    //console.log(response)
                    if (!response.data.error) {
                        let newWindow = window.open("");
                        newWindow.document.write(
                            "<body style='margin:0'><iframe style='border: none;' width='100%' height='100%' src='data:application/pdf;base64, " +
                            encodeURI(response.data) + "'></iframe></body>"
                        )
                    } else {
                        alert('Для данного заказа не создан упаковочный лист.');
                    }
                });
            },
            reorder: function(orderId) {
                let self = this;
                self.orderID = orderId;
                rm_katris.makePost('katrisOrdersState', 'checkOldOrder', {'orderId': orderId}, null, function(response) {
                    if (response.status === 'OK') {
                        self.reorderItemsListAbsent = [];
                        response = JSON.parse(response.data);

                        self.reorderStatus = (response.status === true);

                        for (let key in response.g) {
                            self.reorderItemsListAbsent.push(response.g[key]);
                        }

                        self.$modal.show('reorder');
                    }
                });
            },
            step2: function() {
                this.$modal.hide('reorder');
                window.open('/reorder/' + this.orderID);
            },
            openOrder: function(orderID) {
                window.open('/order/' + orderID);
            },
        }
    }
</script>

<style scoped>
    .ordersState .orderTop {
        background-color: #f8f9fa;
    }
    .ordersState .orderBottom {
        background-color: #f8f9fa;
    }

    .ordersStateTableHeader {
        font-weight: 600;
        border-top: 1px solid #dfdfdf;
    }

    .ordersStateTableHeader .blockInner {
        height: 97px;
    }

    .ordersStateBlock {
        background-color: #f8f9fa;
        border-top: 1px solid #dfdfdf;
        border-bottom: 1px solid #dfdfdf;
        margin-bottom: 25px;
    }

    .ordersStateBlock .row > div {

    }
    .ordersStateBlock hr {
        margin: 0;
    }

    .ordersStateBlock .blockInner, .ordersStateTableHeader .blockInner {
        padding: 0.6rem;

        display: table-cell;
        vertical-align: middle;
    }

    .ordersStateBlock .top .blockInner {
        height: 64px;
    }
    .ordersStateBlock .bottom .blockInner {
        height: 105px;
    }

    .vdp-datepicker {
        width: 110px;
    }

    .list-unstyled .active {
        font-weight: 600;
    }

    .list-unstyled span {
        color: #4e555b;
    }
</style>
